import { render, staticRenderFns } from "./order-pane.vue?vue&type=template&id=25250ba6&scoped=true&"
import script from "./order-pane.vue?vue&type=script&lang=ts&"
export * from "./order-pane.vue?vue&type=script&lang=ts&"
import style0 from "./order-pane.vue?vue&type=style&index=0&id=25250ba6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25250ba6",
  null
  
)

export default component.exports